const LAST_ADMIN_LOGIN_KEY = "isAdminLogin";

export const readLastAdminLogin = () => {
  try {
    return localStorage.getItem(LAST_ADMIN_LOGIN_KEY) === "true";
  } catch {
    return false;
  }
};

export const writeLastAdminLogin = (value) => {
  try {
    localStorage.setItem(LAST_ADMIN_LOGIN_KEY, value ? "true" : "false");
  } catch {}
};

export const getDashboardRouteForUser = (user) =>
  Boolean(user?.inhouseAdmin) && readLastAdminLogin()
    ? "/admin-dashboard"
    : "/dashboard";
